import React, { Component } from "react";
import AppDynamicFilterModal from "../../../partials/AppDynamicFilterModal";

export class LeadsSearch extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: {
        limit: 10,
        order_by: "updatedAt",
        order_direction: "DESC",
        page: 1,
      },
      openDrawer: false,
    };
    this.fields = [
      {
        name: "telecaller",
        label: "Tele Callers",
        type: "select",
        options: [],
        placeholder: "Tele Callers",
      },
      {
        name: "status",
        label: "Status",
        type: "select",
        options: _enum.ADMIN_LEADS_STATUS_WITH_FOLLOW_UP,
        placeholder: "Status",
      },
      {
        name: "startDate",
        label: "Start Date",
        type: "date",
        placeholder: "Start Date",
      },
      {
        name: "endDate",
        label: "End Date",
        type: "text",
        type: "date",
        placeholder: "End Date",
      },
      {
        label: "Source",
        name: "source",
        type: "select",
        options: _enum.SOURCES,
        placeholder: "Please Enter",
      },
    ];
    this.isAdmin = this.props?.$store?.persona === _enum.ROUTE_PERSONAS.admin;
  }

  componentDidMount() {
    this.getAllTelecallers();
  }

  getAllTelecallers = () => {
    this.props.apis
      .apiGetEmployee({ role: "SALES" })
      .then(({ data, total }) => {
        let telecaller = this.fields.find((o) => o.name == "telecaller");
        telecaller.options = data.options("profileId", "name");
      });
  };

  toggleDrawer = () => {
    this.setState((prev) => ({ openDrawer: !prev.openDrawer }));
  };

  closeDrawer = () => {
    this.setState({ openDrawer: false });
  };

  onSearch = (formData) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, false);
  };

  onReset = (formData, reset) => {
    let data = Object.filter(formData, (val) => val);
    this.props.onSearch && this.props.onSearch(data, reset);
  };

  render() {
    let { isAdmin } = this;
    let {
      activeKey,
      downloadTemplateLeads,
      addBulkUploadModalFields,
      bulkUploadModalRef,
    } = this.props;
    let { openDrawer } = this.state;
    return (
      <div className="d-flex align-items-center justify-content-end">
        <div
          className={Object.className({
            "header_btn_box my-3": true,
            hidden: !isAdmin || activeKey !== _enum.PERSONAS.admin,
          })}
        >
          <a
            className="btn btn-sm btn-outline-secondary me-2"
            href={downloadTemplateLeads()}
          >
            <i className="fa fa-download me-2"></i>
            <span>Download Template</span>
          </a>
          <button
            className="btn btn-sm btn-outline-secondary me-2"
            onClick={(e) => addBulkUploadModalFields(e)}
            ref={bulkUploadModalRef}
            data-bs-toggle="modal"
            data-bs-target="#bulkUploadModal"
          >
            <i className="fa fa-upload me-2"></i>
            <span>Bulk Upload</span>
          </button>
        </div>
        <button
          type="button"
          className="btn filter_modal_btn"
          onClick={(...args) => this.toggleDrawer(...args)}
        >
          <i class="fa-solid fa-filter me-2"></i>
          <span>Filters</span>
        </button>
        <AppDynamicFilterModal
          open={openDrawer}
          onClose={this.closeDrawer}
          fields={this.fields}
          onSearch={this.onSearch}
          onReset={this.onReset}
        />
      </div>
    );
  }
}

export default constore(LeadsSearch);
